import { useQuery } from '@tanstack/react-query';

import { type Enrollment } from '~entities/student/modal/enrollment';
import { type Medical } from '~entities/student/modal/medical';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface ClassActiveStudent {
  _id: string;
  name: string;
  dob: string;
  familyName: string;
  gender: string;
  tShirtSize: string;
  mobileNo: string;
  studentEmail: string;
  transportation: string;
  medical: Medical;
  enrollments: Array<Enrollment>;
  parentId: {
    familyName: string;
  };
  studioId: string;
  profilePicUrl: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
}
interface GetStudentsByClassIdParams {
  classId?: string;
}

export const getStudentsByClassIdActiveAPI = async (
  params: GetStudentsByClassIdParams,
) => {
  const response = await baseAPI.get<Array<ClassActiveStudent>>(
    `/students/${params.classId}/class/active`,
  );
  return response.data;
};

export const getStudentsByClassIdActiveOptions = (
  params: GetStudentsByClassIdParams,
) => ({
  queryKey: [KEYS.STUDENTS, params.classId],
  queryFn: () => getStudentsByClassIdActiveAPI(params),
  enabled: !!params.classId,
});

export const useGetStudentsByClassIdActive = (
  params: GetStudentsByClassIdParams,
) => {
  return useQuery(getStudentsByClassIdActiveOptions(params));
};
